import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { PagesComponent } from './pages/pages.component';
import { PagesPreviewComponent } from './pages/preview/preview.component';
import { DynamicTablePreviewComponent } from './pages/preview/dynamic-table-preview/dynamic-table-preview.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { FilterProspecComponent } from './filter/prospec/prospec.component';
import { HomeComponent } from './home/home.component';
import { FilterPensionComponent } from './filter/pension/pension.component';
import { FilterHealthComponent } from './filter/health/health.component';
import { NewsHighlightComponent } from './news-highlight/news-highlight.component';
import { PublishingHighlightComponent } from './publishing-highlight/publishing-highlight.component';

const routes: Routes = [
  {
    path: '',
    component: HomeComponent
  },
  {
    path: 'filtro/planos/previdencia',
    component: FilterPensionComponent,
    data: {title: 'Vivest - Previdencia'}
  },
  {
    path: 'filtro/planos/saude',
    component: FilterHealthComponent,
    data: {title: 'Vivest - Saude'}
  },
  {
    path: 'filtro/:id',
    component: FilterProspecComponent
  },
  {
    path: 'paginas/:section/:slug',
    component: PagesComponent
  },
  {
    path: 'paginas/:slug',
    component: PagesComponent
  },
  {
    path: 'preview/tabela-dinamica/:id',
    component: DynamicTablePreviewComponent
  },
  {
    path: 'preview/:section/:slug',
    component: PagesPreviewComponent
  },
  {
    path: 'preview/:slug',
    component: PagesPreviewComponent
  },
  {
    path: 'nao-encontrado',
    component: NotFoundComponent,
    data: {title: 'Vivest - Página não encontrada'}
  },
  {
    path: 'noticias',
    component: NewsHighlightComponent,
    data: {title: 'Vivest - Noticias'}
  },
  {
    path: 'noticias/:category',
    component: NewsHighlightComponent
  },
  {
    path: 'noticias/:category/:slug',
    component: NewsHighlightComponent
  },
  {
    path: 'publicacoes',
    component: PublishingHighlightComponent,
    data: {title: 'Vivest - Publicacoes'}
  },
  {
    path: 'publicacoes/:category',
    component: PublishingHighlightComponent
  },
  {
    path: 'publicacoes/:category/:subcategory',
    component: PublishingHighlightComponent
  },
  {
    path: 'publicacoes/:category/:subcategory/:title',
    component: PublishingHighlightComponent
  },
  {
    path: 'invest',
    loadChildren: () => import('./invest/invest.module').then(m => m.InvestModule),
  },
  {
    path: '**',
    redirectTo: ''
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
